module.exports = __webpack_public_path__ + "img/contact_bd.4ad1972b.png";